import { Component } from '@angular/core';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { MODAL, ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-help-action',
  templateUrl: './help-action.component.html',
})
export class HelpActionComponent {
  constructor(private modalService: ModalService) {}

  protected openTips() {
    this.modalService.display(MODAL.HELP_TIPS);
  }

  protected readonly faQuestion = faQuestion;
}
